export default {
  descricao: {
    value: null,
    maxlength: 200,
    required: true,
    state: null
  },
  tipo: {
    value: 0,
    required: true,
    state: null,
    options: []
  },
  itens: {
    value: [],
    required: false,
    state: null
  },
  empresaID: {
    value: null
  },
  pciModeloItem: {
    value: null,
    options: []
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/reports/report-form.js